import '@babel/polyfill'
import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App'
import router from './router'
import VueChatScroll from 'vue-chat-scroll'
import store from "./store"
import Vuex from 'vuex'

Vue.config.productionTip = false
Vue.use(VueChatScroll)
Vue.use(Vuex)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
